import { useOktaAuth } from '@okta/okta-react';
import { useMutation } from '@tanstack/react-query';
import { SetPasswordParams } from './types/SetPasswordParams';
import useRenewOktaToken from '../../../libs/okta/useRenewOktaToken';
import { useUserStore } from '../../../../../../libs/state-management/src';

const useSetPassword = (onError = () => {}) => {
  const { oktaAuth } = useOktaAuth();

  const { renewToken } = useRenewOktaToken();

  return useMutation<string, Error, SetPasswordParams>({
    mutationKey: ['set-password'],
    onError,
    mutationFn: async ({ password, oldPassword }) => {
      const transaction = await oktaAuth.tx.resume();

      let data;

      if (transaction.resetPassword) {
        console.log('resetting password');

        data = await transaction?.resetPassword?.({
          newPassword: password,
        });
      }

      if (transaction.changePassword && !transaction.resetPassword) {
        console.log('changing password');

        data = await transaction.changePassword?.({
          newPassword: password,
          oldPassword: oldPassword,
        });
      }

      const sessionToken = data?.sessionToken;

      const { tokens } = await oktaAuth.token.getWithoutPrompt({
        responseType: 'code',
        scopes: ['openid', 'email'],
        sessionToken,
        // redirectUri: window.location.origin + '/auth-callback?'
      });

      console.log('tokens', tokens);

      if (tokens.accessToken) {
        oktaAuth.tokenManager.add('accessToken', tokens.accessToken);
      }

      if (tokens.idToken) {
        oktaAuth.tokenManager.add('idToken', tokens.idToken);
      }

      if (!tokens.accessToken?.accessToken) {
        throw new Error('no access token foudn');
      }

      useUserStore.getState().setToken(tokens.accessToken?.accessToken);
      // useUserStore.getState().setIsLoadingToken(false);
      // await renewToken();

      return '';
    },
  });
};

export default useSetPassword;
